<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive">
              <template slot="header">
                <div class="row">
                  <div class="col">
                    <h4 class="card-title">Gestión de gastos</h4>
                    <p class="card-category">Gastos por vehículos</p>
                  </div>
                </div>
              </template>
              <vs-tabs color="#004aad">
                <vs-tab label="Lista" icon="list">
                  <div class="row">
                    <div class="col-xl-2 col-md-2 col-6">
                      <vs-input label="Buscar" icon="search" class="inputx" type="text" placeholder="ㅤItem..." v-model="search"/>
                    </div>
                    <div class="col-xl-2 col-md-2 col-6" style="align-self: flex-end;">
                      <vs-select label="Vehículo" class="selectExample" placeholder="Seleccionar" v-model="filter">
                        <vs-select-item :value="null" text="Todos"/>
                        <vs-select-item :key="index" :value="item.id_vehicle" :text="item.placa" v-for="item,index in listVehicles" />
                      </vs-select>
                    </div>
                    <div class="col-xl-2 col-md-2 col-6"><vs-input type="date" label="Inicio" v-model="inicio"/></div>
                    <div class="col-xl-2 col-md-2 col-6"><vs-input type="date" label="Fin" class="inputx" v-model="fin"/></div>
                    
                    <div style="align-self: flex-end;" class="col-xl-1 col-md-1 col-4">
                      <vs-tooltip key="button-filter" text="Filtrar">
                        <vs-button icon="search" style="width: 100%!important; font-size: 1rem; margin: 0.5rem 0.1rem;" @click="getListExpenses()" color="#004aad" type="filled"></vs-button>
                      </vs-tooltip>
                    </div>
                    <div style="align-self: flex-end;" class="col-xl-1 col-md-1 col-4">
                      <vs-tooltip key="button-create" text="Crear">
                        <vs-button icon="note_add" style="width: 100%!important; font-size: 1rem; margin: 0.5rem 0.1rem;" color="#004aad" type="filled" @click="openPopupCreateExpense()"></vs-button>
                      </vs-tooltip>
                    </div>
                    <div style="align-self: flex-end;" class="col-xl-1 col-md-1 col-4">
                      <vs-tooltip key="button-report" text="Reporte">
                        <vs-button icon="analytics" style="width: 100%!important; font-size: 1rem; margin: 0.5rem 0.1rem;" color="#004aad" type="filled" @click="openPopupReport()"></vs-button>
                      </vs-tooltip>
                    </div>
                  </div>
                  <div class="con-tab-ejemplo" v-if="listExpenses.length>0">
                    <l-table class="table-hover table-striped"
                      @edit="openPopupCreateExpense"
                      @delete="openDeleteExpense"
                      :columns="tableExpenses.columns"
                      :options="tableExpenses.options"
                      :data="listExpenses">
                    </l-table>
                  </div>
                  <div class="con-tab-ejemplo" v-else>
                    No hay datos para mostrar
                  </div>
                </vs-tab>
                <vs-tab label="Categorías" icon="category">
                  <div style="float: right;" class="col-xl-1 col-md-1 col-4">
                    <vs-tooltip key="button-create" text="Crear">
                      <vs-button icon="note_add" style="width: 100%!important; font-size: 1rem; margin: 0.5rem 0.1rem;" color="#004aad" type="filled" @click="openPopupCreateCategory()"></vs-button>
                    </vs-tooltip>
                  </div>
                  <div class="con-tab-ejemplo" v-if="listCategories.length>0">
                    <l-table class="table-hover table-striped"
                      @edit="openPopupCreateCategory"
                      @delete="openDeleteCategory"
                      :columns="tableCategories.columns"
                      :options="tableCategories.options"
                      :data="listCategories">
                    </l-table>
                  </div>
                  <div class="con-tab-ejemplo" v-else>
                    No hay datos para mostrar
                  </div>
                </vs-tab>
                <vs-tab label="Items" icon="inventory">
                  <div style="float: right;" class="col-xl-1 col-md-1 col-4">
                    <vs-tooltip key="button-create" text="Crear">
                      <vs-button icon="note_add" style="width: 100%!important; font-size: 1rem; margin: 0.5rem 0.1rem;" color="#004aad" type="filled" @click="openPopupCreateItem()"></vs-button>
                    </vs-tooltip>
                  </div>
                  <div class="con-tab-ejemplo" v-if="listItems.length>0">
                    <l-table class="table-hover table-striped"
                      @edit="openPopupCreateItem"
                      @delete="openDeleteItem"
                      :columns="tableItems.columns"
                      :options="tableItems.options"
                      :data="listItems">
                    </l-table>
                  </div>
                  <div class="con-tab-ejemplo" v-else>
                    No hay datos para mostrar
                  </div>
                </vs-tab>
              </vs-tabs>
              <vs-popup classContent="popup-example"  title="Categoría" :active.sync="popupCreateCategory">
                <div class="row" style="margin: 0;">
                  <vs-input class="inputx" label="Nombre" placeholder="Nombre" v-model="formCategory.name"/>
                  <vs-input class="inputx" label="Descripción" placeholder="Descripción" v-model="formCategory.description"/>
                  <vs-checkbox style="font-size: medium; padding-top: 1rem;" v-model="formCategory.status">Estado</vs-checkbox>
                </div>
                <div style="text-align:right;">
                  <vs-button style="width: auto; font-size: 1rem; margin-top: 1rem; float: right;" @click="saveCategory" color="#004aad" type="filled" icon="save"><span v-if="!formCategory.id_expense_category">Guardar</span><span v-else>Editar</span></vs-button>
                </div>
              </vs-popup>
              <vs-popup classContent="popup-example"  title="Item" :active.sync="popupCreateItem">
                <div class="row" style="margin: 0;">
                  <vs-input class="inputx" label="Nombre" placeholder="Nombre" v-model="formItem.name"/>
                  <vs-input class="inputx" label="Descripción" placeholder="Descripción" v-model="formItem.description"/>
                  <vs-select autocomplete
                    class="selectExample" style="width: 100%!important;"
                    label="Categoría"
                    placeholder="Seleccione..."
                    v-model="formItem.id_expense_category"
                    >
                    <vs-select-item :key="index" :value="item.id_expense_category" :text="item.name" v-for="item,index in listCategories" />
                  </vs-select>
                  <vs-checkbox style="font-size: medium; padding-top: 1rem;" v-model="formItem.status">Estado</vs-checkbox>
                </div>
                <div style="text-align:right;">
                  <vs-button style="width: auto; font-size: 1rem; margin-top: 1rem; float: right;" @click="saveItem" color="#004aad" type="filled" icon="save"><span v-if="!formItem.id_expense_item">Guardar</span><span v-else>Editar</span></vs-button>
                </div>
              </vs-popup>
              <vs-popup classContent="popup-example"  title="Gasto" :active.sync="popupCreateExpense">
                <div class="row" style="margin: 0;">
                  <div style="display: flex; width: 100%;">
                    <vs-select autocomplete
                      class="selectExample" style="width: 100%!important;"
                      label="Item (*)"
                      placeholder="Seleccione Item..."
                      v-model="formExpense.id_expense_item"
                      >
                      <vs-select-item :key="index" :value="item.id_expense_item" :text="item.name" v-for="item,index in listItems" />
                    </vs-select>
                    <vs-select autocomplete
                      class="selectExample" style="width: 100%!important; margin-left: 0.5rem;"
                      label="Vehicle (*)"
                      placeholder="Seleccione Vehículo..."
                      v-model="formExpense.id_vehicle"
                      >
                      <vs-select-item :key="index" :value="item.id_vehicle" :text="item.placa" v-for="item,index in listVehicles" />
                    </vs-select>
                  </div>
                  <div style="display: flex; width: 100%;">
                    <div style="width: 100%; padding-top: 0.3rem;">
                      <label style="font-size: .85rem;color: rgba(0,0,0,.7);padding-left: 5px;" for="formExpense.km">Kilómetros</label>
                      <money class="custom-money" label="Total" v-model="formExpense.km" min="0" v-bind="moneyNumber"></money>
                    </div>
                    <vs-input style="margin-left: 0.5rem;" class="inputx" type="number" min="0" label="Cantidad (*)" placeholder="Cantidad" v-model="formExpense.quantity"/>
                  </div>
                  <div style="display: flex; width: 100%;">
                    <div style="width: 100%;padding-top: 0.3rem;">
                      <label style="font-size: .85rem;color: rgba(0,0,0,.7);padding-left: 5px;" for="formExpense.unit_value">Valor unitario (*)</label>
                      <money class="custom-money" label="Total" v-model="formExpense.unit_value" min="0" v-bind="money"></money>
                    </div>
                    <div style="margin-left: 0.5rem; width: 100%;padding-top: 0.3rem;">
                      <label style="font-size: .85rem;color: rgba(0,0,0,.7);padding-left: 5px;" for="formExpense.total">Total</label>
                      <money class="custom-money" disabled label="Total" :value="formExpenseTotal" min="0" v-bind="money" readonly></money>
                    </div>
                  </div>
                  <vs-input  type="datetime-local" label="Fecha" class="inputx" v-model="formExpense.date"/>
                  <vs-input class="inputx" label="Descripción" placeholder="Descripción" v-model="formExpense.description"/>
                  <vs-input class="inputx" label="Referencia" placeholder="Referencia" v-model="formExpense.reference"/>
                </div>
                <div style="text-align:right;">
                  <vs-button style="width: auto; font-size: 1rem; margin-top: 1rem; float: right;" @click="saveExpense" color="#004aad" type="filled" icon="save"><span v-if="!formExpense.id_expense">Guardar</span><span v-else>Editar</span></vs-button>
                </div>
              </vs-popup>
              <vs-popup :fullscreen="true" classContent="popup-example"  title="Reporte" :active.sync="popupReport">
                <div class="row" style="margin: 0;">
                  <div style="display: flex; width: 100%;flex-direction: row-reverse;">
                    <div class="col-xl-2 col-md-2 col-4">
                      <vs-tooltip key="button-create" text="Exportar PDF">
                        <vs-button icon="picture_as_pdf" style="width: 100%!important; font-size: 1rem; margin: 0.5rem 0.1rem;" color="#004aad" type="filled" @click="pdfReportExpenses()"></vs-button>
                      </vs-tooltip>
                    </div>
                    <div class="col-xl-2 col-md-2 col-4">
                      <vs-tooltip key="button-create" text="Exportar Excel">
                        <vs-button icon="difference" style="width: 100%!important; font-size: 1rem; margin: 0.5rem 0.1rem;" color="#004aad" type="filled" @click="excelReportExpenses()"></vs-button>
                      </vs-tooltip>
                    </div>
                  </div>
                  <div class="col-xl-4 col-md-4 col-12">
                    <chart-card :chart-data="pieChartVehicle.data" chart-type="Pie" ref="chartVehicle">
                      <template slot="header">
                        <h4 class="card-title">Vehículos</h4>
                        <p class="card-category">Total: {{ sumTotalVehicle.toLocaleString('en-EN', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).replace(/\,/g, '.') }}</p>
                      </template>
                      <template slot="footer">
                        <div class="legend">
                          <p :key="index" v-for="(vehicle, index) in pieChartVehicle.data.names">
                            <i class="fa fa-circle" :style="{ color: colors[index % colors.length] }"></i> {{ vehicle }}: {{(pieChartVehicle.data.values[index]).toLocaleString('en-EN', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).replace(/\,/g, '.')}} ({{ pieChartVehicle.data.percentage[index] }})
                          </p>
                        </div>
                      </template>
                    </chart-card>
                  </div>
                  <div class="col-xl-4 col-md-4 col-12">
                    <chart-card :chart-data="pieChartItem.data" chart-type="Pie" ref="chartItem">
                      <template slot="header">
                        <h4 class="card-title">Items</h4>
                        <p class="card-category">Total: {{ sumTotalItem.toLocaleString('en-EN', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).replace(/\,/g, '.') }}</p>
                      </template>
                      <template slot="footer">
                        <div class="legend">
                          <p :key="index" v-for="(item, index) in pieChartItem.data.names">
                            <i class="fa fa-circle" :style="{ color: colors[index % colors.length] }"></i> {{ item }}: {{(pieChartItem.data.values[index]).toLocaleString('en-EN', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).replace(/\,/g, '.')}} ({{ pieChartItem.data.percentage[index] }})
                          </p>
                        </div>
                      </template>
                    </chart-card>
                  </div>
                  <div class="col-xl-4 col-md-4 col-12">
                    <chart-card :chart-data="pieChart.data" chart-type="Pie" ref="chart">
                      <template slot="header">
                        <h4 class="card-title">Categorías</h4>
                        <p class="card-category">Total: {{ sumTotal.toLocaleString('en-EN', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).replace(/\,/g, '.') }}
                        </p>
                      </template>
                      <template slot="footer">
                        <div class="legend">
                          <p :key="index" v-for="(category, index) in pieChart.data.names">
                            <i class="fa fa-circle" :style="{ color: colors[index % colors.length] }"></i> {{ category }}: {{(pieChart.data.values[index]).toLocaleString('en-EN', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).replace(/\,/g, '.')}} ({{ pieChart.data.percentage[index] }})
                          </p>
                        </div>
                      </template>
                    </chart-card>
                  </div>
                </div>
              </vs-popup>
            </card>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/BaseTable.vue'
    import Card from 'src/components/Cards/Card.vue'
    import StatsCard from 'src/components/Cards/StatsCard.vue'
    import ChartCard from 'src/components/Cards/ChartCard.vue'
    import getSecret from '../helpers/get-secret';
    const serverUrl=getSecret('SERVER_URL');
    const CategoriesColumns = [{text:'Nombre', value:'name'}, {text:'Fecha', value:'created_at'}, {text:'Estado', value:'status'},{text:'Opciones', value:'options'}]
    const CategoriesOptions = [{text:'Editar', icon:'nc-settings-gear-64', action:'edit'},{text:'Eliminar', icon:'nc-simple-remove', action:'delete'}]
    const ItemsColumns = [{text:'Nombre', value:'name'}, {text:'Categoría', value:'category_name'}, {text:'Fecha', value:'created_at'}, {text:'Estado', value:'status'},{text:'Opciones', value:'options'}]
    const ItemsOptions = [{text:'Editar', icon:'nc-settings-gear-64', action:'edit'},{text:'Eliminar', icon:'nc-simple-remove', action:'delete'}]
    const ExpensesColumns = [{text:'Vehículo', value:'vehicle_placa'}, {text:'Item', value:'item_name'}, {text:'Fecha', value:'date'}, {text:'Total', value:'total'},{text:'Opciones', value:'options'}]
    const ExpensesOptions = [{text:'Editar', icon:'nc-settings-gear-64', action:'edit'},{text:'Eliminar', icon:'nc-simple-remove', action:'delete'}]
    export default {
      components: {
        LTable,
        Card,
        StatsCard,
        ChartCard,
      },
      data () {
        return {
          colors: ['#1DC7EA','#FB404B','#FFA534','#9368E9','#87CB16','#1F77D0','#5e5e5e','#dd4b39','#35465c','#e52d27','#55acee','#cc2127','#1769ff','#6188e2','#a748ca'],
          search:'',
          filter:null,
          inicio:'',
          fin:'',
          popupReport:false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: '$ ',
            suffix: '',
            precision: 0,
            masked: false
          },
          moneyNumber: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: ' (Km)',
            precision: 2,
            masked: false
          },
          activeConfirm:false,
          id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
          id_user:JSON.parse(localStorage.getItem('jwt_user')).id,
          counter:JSON.parse(localStorage.getItem('jwt_licencia')).counter,
          tableCategories: {
            columns: [...CategoriesColumns],
            options: [...CategoriesOptions]
          },
          tableItems: {
            columns: [...ItemsColumns],
            options: [...ItemsOptions]
          },
          tableExpenses: {
            columns: [...ExpensesColumns],
            options: [...ExpensesOptions]
          },
          listCategories:[],
          listItems:[],
          listExpenses:[],
          listExpensesSource:[],
          listVehicles:[],
          popupCreateCategory:false,
          formCategory:{
            id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
            name:null,
            description:null,
            id_expense_category:null,
            status:true,
          },
          popupCreateItem:false,
          formItem:{
            id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
            name:null,
            description:null,
            id_expense_item:null,
            status:true,
            id_expense_category:null,
          },
          popupCreateExpense:false,
          formExpense:{
            id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
            id_vehicle:null,
            description:null,
            reference:null,
            km:0,
            quantity:1,
            unit_value:null,
            date:0,
            id_expense_item:null,
            id_expense:null,
          },
          pieChart: {
            data: {
              labels: ['40%', '20%', '40%'],
              series: [40, 20, 40],
              names: ['Uno','Dos','Tres'],
              values: [20,20,20],
              percentage: ['40%', '20%', '40%']
            }
          },
          pieChartVehicle: {
            data: {
              labels: ['40%', '20%', '40%'],
              series: [40, 20, 40],
              names: ['Uno','Dos','Tres'],
              values: [20,20,20],
              percentage: ['40%', '20%', '40%']
            }
          },
          pieChartItem: {
            data: {
              labels: ['40%', '20%', '40%'],
              series: [40, 20, 40],
              names: ['Uno','Dos','Tres'],
              values: [20,20,20],
              percentage: ['40%', '20%', '40%']
            }
          },
        }
      },
      computed: {
        formExpenseTotal() {
          return this.formExpense.quantity && this.formExpense.quantity > 0
            ? this.formExpense.quantity * this.formExpense.unit_value
            : 0;
        },
        sumTotal(){
          return this.pieChart.data.values.reduce((total, valor) => total + valor, 0);
        },
        sumTotalVehicle(){
          return this.pieChartVehicle.data.values.reduce((total, valor) => total + valor, 0);
        },
        sumTotalItem(){
          return this.pieChartItem.data.values.reduce((total, valor) => total + valor, 0);
        },
      },
      watch:{ 
        search: function(val){
          if(val!=null && val!='' && val!=undefined){
            this.filtrarItems();
          } else{
            this.listExpenses=this.listExpensesSource;
          }
        },
      },
      methods:{
        filtrarItems() {
          this.listExpenses=this.listExpensesSource.filter(item =>
            item.item_name.toLowerCase().includes(this.search.toLowerCase())
          );
        },
        validateStatus(){
          this.axios.get(serverUrl+'/api/validateStatus/'+this.id_company)
            .then(res => {   
              if(res.data.info.licencia.status_commercial == 'MORA'){
                window.localStorage.removeItem('jwt_user');
                window.localStorage.removeItem('jwt_licencia');
                window.localStorage.removeItem('jwt_token');
                location.href = location.origin+'/login';
              } else{
                let tipo = {
                  "name": res.data.info.licencia.name,
                  "id_company": res.data.info.licencia.id_company,
                  "payment_data": res.data.info.licencia.payment_data,
                  "status_commercial": res.data.info.licencia.status_commercial,
                  "counter": res.data.info.licencia.counter,
                }
                window.localStorage.setItem('jwt_licencia', JSON.stringify(tipo));
                if(this.counter!=res.data.info.licencia.counter)location.reload();
              }
            })
            .catch(err => {
              console.log(err);
            })
        },
        getListVehicles(){
          return new Promise((resolve, reject) => {
            this.$vs.loading({
              type:'point',
              text:'Consultando...',
              color:'#004aad'
            })
            this.axios.get(serverUrl+'/api/getListVehicles/'+this.id_company)
              .then(res => {   
                if(res.data.status==200)this.listVehicles=res.data.vehicles
                else this.listVehicles=[]
                this.$vs.loading.close()
                resolve();
              })
              .catch(err => {
                console.log(err.data);
                this.$notifications.notify({
                  message: `<span><b>¡Error!</b><br>Ocurrió al consultar los vehículos.</span>`,
                  icon: 'nc-icon nc-support-17',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'danger'
                })
                this.$vs.loading.close()
                resolve();
              });
          });
        },
        getListCategories(){
          return new Promise((resolve, reject) => {
            this.$vs.loading({
              type:'point',
              text:'Consultando...',
              color:'#004aad'
            })
            this.axios.get(serverUrl+'/api/get_list_expense_categories/'+this.id_company)
              .then(res => {
                if(res.data.status==200)this.listCategories=res.data.categories
                else this.listCategories=[]
                this.$vs.loading.close()
                resolve();
              })
              .catch(err => {
                console.log(err);
                this.$notifications.notify({
                  message: `<span><b>¡Error!</b><br>Ocurrió al consultar las Categorías.</span>`,
                  icon: 'nc-icon nc-support-17',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'danger'
                })
                this.$vs.loading.close()
                resolve();
              })
          })
        },
        openPopupCreateCategory(item=null){
          if(item){
            console.log(item)
            this.formCategory.name=item.name
            this.formCategory.description=item.description
            this.formCategory.id_expense_category=item.id_expense_category
            this.formCategory.status=item.status
          } else{
            this.formCategory.name=null
            this.formCategory.description=null
            this.formCategory.id_expense_category=null
            this.formCategory.status=true
          }
          this.popupCreateCategory=true
        },
        saveCategory(){
          this.$vs.loading({
            type:'point',
            text:'Guardando...',
            color:'#004aad'
          })
          if(!this.formCategory.name || this.formCategory.name==''){
            this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>El nombre es obligatorio.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              setTimeout(() => {
                this.$vs.loading.close()
              }, 200);
              this.popupCreateCategory=false
              return false
          }
          this.axios.post(serverUrl+'/api/save_category', this.formCategory)
            .then(res => {
              if(res.data.status==200){
                this.$notifications.notify({
                  message: `<span><b>¡Éxito!</b><br>Categoría Guardada.</span>`,
                  icon: 'nc-icon nc-send',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'info'
                });
                this.popupCreateCategory=false
                this.formCategory.name=null
                this.formCategory.description=null
                this.formCategory.id_expense_category=null
                this.formCategory.status=true
                this.$vs.loading.close()
                this.getListCategories()
              }
            }).catch(err => {
              console.log(err);
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió al guardar la Categoría.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.$vs.loading.close()
              this.popupCreateCategory=false
            })
        },
        openDeleteCategory(item){
          this.formCategory.id_expense_category=item.id_expense_category
          this.$vs.dialog({
            type:'confirm',
            color: '#004aad',
            title: `Eliminar`,
            acceptText: 'Eliminar',
            cancelText: 'Cancelar',	
            text: '¿Esta seguro que desea eliminar esta Categoría?',
            accept:this.deleteCategory
          });
        },
        deleteCategory(){
          this.$vs.loading({
            type:'point',
            text:'Eliminando...',
            color:'#004aad'
          })
          this.axios.get(serverUrl+'/api/delete_category/'+this.formCategory.id_expense_category)
            .then(res => {
              if(res.data.status==200){
                this.$notifications.notify({
                  message: `<span><b>¡Éxito!</b><br>Categoría Eliminada.</span>`,
                  icon: 'nc-icon nc-send',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'info'
                });
              }
              this.$vs.loading.close()
              this.getListCategories()
            })
            .catch(err => {
              console.log(err);
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió al Eliminando la Categoría.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.$vs.loading.close()
            })
        },
        getListItems(){
          return new Promise((resolve, reject) => {
            this.$vs.loading({
              type:'point',
              text:'Consultando...',
              color:'#004aad'
            })
            this.axios.get(serverUrl+'/api/get_list_expense_items/'+this.id_company)
              .then(res => {
                if(res.data.status==200)this.listItems=res.data.items
                else this.listItems=[]
                this.$vs.loading.close()
                resolve();
              })
              .catch(err => {
                console.log(err);
                this.$notifications.notify({
                  message: `<span><b>¡Error!</b><br>Ocurrió al consultar los Items.</span>`,
                  icon: 'nc-icon nc-support-17',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'danger'
                })
                this.$vs.loading.close()
                resolve();
              })
          })
        },
        openPopupCreateItem(item=null){
          if(item){
            console.log(item)
            this.formItem.name=item.name
            this.formItem.description=item.description
            this.formItem.id_expense_item=item.id_expense_item
            this.formItem.id_expense_category=item.id_expense_category
            this.formItem.status=item.status
          } else{
            this.formItem.name=null
            this.formItem.description=null
            this.formItem.id_expense_item=null
            this.formItem.status=true
            this.formItem.id_expense_category=null
          }
          this.popupCreateItem=true
        },
        saveItem(){
          this.$vs.loading({
            type:'point',
            text:'Guardando...',
            color:'#004aad'
          })
          if(!this.formItem.name || this.formItem.name=='' || !this.formItem.id_expense_category || this.formItem.id_expense_category==''){
            this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>El nombre y la categoría son obligatorios.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              setTimeout(() => {
                this.$vs.loading.close()
              }, 200);
              this.popupCreateItem=false
              return false
          }
          this.axios.post(serverUrl+'/api/save_item', this.formItem)
            .then(res => {
              if(res.data.status==200){
                this.$notifications.notify({
                  message: `<span><b>¡Éxito!</b><br>Item Guardado.</span>`,
                  icon: 'nc-icon nc-send',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'info'
                });
                this.popupCreateItem=false
                this.formItem.name=null
                this.formItem.description=null
                this.formItem.id_expense_item=null
                this.formItem.id_expense_category=null
                this.formItem.status=true
                this.$vs.loading.close()
                this.getListItems()
              }
            }).catch(err => {
              console.log(err);
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió al guardar el Item.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.popupCreateItem=false
              this.$vs.loading.close()
            })
        },
        openDeleteItem(item){
          this.formItem.id_expense_item=item.id_expense_item
          this.$vs.dialog({
            type:'confirm',
            color: '#004aad',
            title: `Eliminar`,
            acceptText: 'Eliminar',
            cancelText: 'Cancelar',	
            text: '¿Esta seguro que desea eliminar este Item?',
            accept:this.deleteExpenseItem
          });
        },
        deleteExpenseItem(){
          this.$vs.loading({
            type:'point',
            text:'Eliminando...',
            color:'#004aad'
          })
          this.axios.get(serverUrl+'/api/delete_item/'+this.formItem.id_expense_item)
            .then(res => {
              if(res.data.status==200){
                this.$notifications.notify({
                  message: `<span><b>¡Éxito!</b><br>Item Eliminado.</span>`,
                  icon: 'nc-icon nc-send',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'info'
                });
              }
              this.$vs.loading.close()
              this.getListItems()
            })
            .catch(err => {
              console.log(err);
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió al Eliminando el Item.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.$vs.loading.close()
            })
        },
        getListExpenses(){
          return new Promise((resolve, reject) => {
            this.$vs.loading({
              type:'point',
              text:'Consultando...',
              color:'#004aad'
            })
            this.axios.get(serverUrl+'/api/get_list_expenses/'+this.id_company+'/'+this.inicio+'/'+this.fin+'/'+this.filter)
              .then(res => {
                this.listExpenses=[]
                this.listExpensesSource=[]
                if(res.data.status==200){
                  this.listExpenses=res.data.expenses
                  this.listExpensesSource=res.data.expenses
                }
                this.$vs.loading.close()
                resolve();
              })
              .catch(err => {
                console.log(err);
                this.$notifications.notify({
                  message: `<span><b>¡Error!</b><br>Ocurrió al consultar los Gastos.</span>`,
                  icon: 'nc-icon nc-support-17',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'danger'
                })
                this.$vs.loading.close()
                resolve();
              })
          })
        },
        openPopupCreateExpense(item=null){
          if(item){
            this.formExpense.id_vehicle=item.id_vehicle
            this.formExpense.description=item.description
            this.formExpense.id_expense_item=item.id_expense_item
            this.formExpense.reference=item.reference
            this.formExpense.km=item.km
            this.formExpense.quantity=item.quantity
            this.formExpense.unit_value=item.unit_value
            this.formExpense.id_expense=item.id_expense
            this.formExpense.date=item.date
          } else{
            this.formExpense.id_vehicle=null
            this.formExpense.description=null
            this.formExpense.reference=null
            this.formExpense.km=0
            this.formExpense.quantity=null
            this.formExpense.unit_value=0
            this.formExpense.id_expense_item=null
            this.formExpense.id_expense=null
            const newDate=new Date();
            const dia = String(newDate.getDate()).padStart(2, '0');
            const mes = String(newDate.getMonth() + 1).padStart(2, '0');
            const anio = newDate.getFullYear();
            const date = `${anio}-${mes}-${dia}`;
            const hours = String(newDate.getHours()).padStart(2, '0');
            const minutes = String(newDate.getMinutes()).padStart(2, '0');
            const hour = `${hours}:${minutes}`;
            this.formExpense.date=date+'T'+hour;
          }
          this.popupCreateExpense=true
        },
        saveExpense(){
          this.$vs.loading({
            type:'point',
            text:'Guardando...',
            color:'#004aad'
          })
          if(!this.formExpense.id_vehicle || this.formExpense.id_expense_item=='' || !this.formExpense.quantity || this.formExpense.quantity==''){
            this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>El Vehículo, Item y cantidad son obligatorios.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              setTimeout(() => {
                this.$vs.loading.close()
              }, 200);
              this.popupCreateExpense=false
              return false
          }
          this.axios.post(serverUrl+'/api/save_expense', this.formExpense)
            .then(res => {
              if(res.data.status==200){
                this.$notifications.notify({
                  message: `<span><b>¡Éxito!</b><br>Gasto Guardado.</span>`,
                  icon: 'nc-icon nc-send',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'info'
                });
                this.formExpense.id_vehicle=null
                this.formExpense.description=null
                this.formExpense.reference=null
                this.formExpense.km=0
                this.formExpense.quantity=null
                this.formExpense.unit_value=0
                this.formExpense.id_expense_item=null
                this.formExpense.id_expense=null
                this.$vs.loading.close()
                this.getListExpenses()
                this.popupCreateExpense=false
              }
            }).catch(err => {
              console.log(err);
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió al guardar el Gasto.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.$vs.loading.close()
              this.popupCreateExpense=false
            })
        },
        openDeleteExpense(item){
          this.formExpense.id_expense=item.id_expense
          this.$vs.dialog({
            type:'confirm',
            color: '#004aad',
            title: `Eliminar`,
            acceptText: 'Eliminar',
            cancelText: 'Cancelar',	
            text: '¿Esta seguro que desea eliminar este Gasto?',
            accept:this.deleteExpense
          });
        },
        deleteExpense(){
          this.$vs.loading({
            type:'point',
            text:'Eliminando...',
            color:'#004aad'
          })
          this.axios.get(serverUrl+'/api/delete_expense/'+this.formExpense.id_expense)
            .then(res => {
              if(res.data.status==200){
                this.$notifications.notify({
                  message: `<span><b>¡Éxito!</b><br>Gasto Eliminado.</span>`,
                  icon: 'nc-icon nc-send',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'info'
                });
              }
              this.$vs.loading.close()
              this.getListExpenses()
            })
            .catch(err => {
              console.log(err);
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió al Eliminando el Gasto.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.$vs.loading.close()
            })
        },
        openPopupReport(){
          this.pieChart.data.labels=[];
          this.pieChart.data.series=[];
          this.pieChart.data.names=[];
          this.pieChart.data.values=[];
          this.pieChart.data.percentage=[];
          this.pieChartVehicle.data.labels=[];
          this.pieChartVehicle.data.series=[];
          this.pieChartVehicle.data.names=[];
          this.pieChartVehicle.data.values=[];
          this.pieChartVehicle.data.percentage=[];
          this.pieChartItem.data.labels=[];
          this.pieChartItem.data.series=[];
          this.pieChartItem.data.names=[];
          this.pieChartItem.data.values=[];
          this.pieChartItem.data.percentage=[];
          const itemsByCategory = [];
          const itemsByVehicle = [];
          const itemsByItem = [];
          this.listExpenses.forEach(item => {
            const id_expense_category = item.id_expense_category;
            const id_vehicle = item.id_vehicle;
            const id_expense_item = item.id_expense_item;
            if (!itemsByCategory.some(entry => entry.id_expense_category === id_expense_category)) {
              itemsByCategory.push({ id_expense_category: id_expense_category, count: 1, value: item.unit_value*item.quantity});
            } else {
              itemsByCategory.find(entry => entry.id_expense_category === id_expense_category).count++;
              itemsByCategory.find(entry => entry.id_expense_category === id_expense_category).value+=item.unit_value*item.quantity;
            }
            if (!itemsByVehicle.some(entry => entry.id_vehicle === id_vehicle)) {
              itemsByVehicle.push({ id_vehicle: id_vehicle, count: 1, value: item.unit_value*item.quantity});
            } else {
              itemsByVehicle.find(entry => entry.id_vehicle === id_vehicle).count++;
              itemsByVehicle.find(entry => entry.id_vehicle === id_vehicle).value+=item.unit_value*item.quantity;
            }
            if (!itemsByItem.some(entry => entry.id_expense_item === id_expense_item)) {
              itemsByItem.push({ id_expense_item: id_expense_item, count: 1, value: item.unit_value*item.quantity});
            } else {
              itemsByItem.find(entry => entry.id_expense_item === id_expense_item).count++;
              itemsByItem.find(entry => entry.id_expense_item === id_expense_item).value+=item.unit_value*item.quantity;
            }
          });
          const categoriesMap = new Map(this.listCategories.map(category => [category.id_expense_category, category.name]));
          const vehiclesMap = new Map(this.listVehicles.map(vehicle => [vehicle.id_vehicle, vehicle.placa]));
          const itemsMap = new Map(this.listItems.map(item => [item.id_expense_item, item.name]));
          itemsByCategory.forEach(category =>{
            this.pieChart.data.percentage.push(((parseInt(category.count)/parseInt(this.listExpenses.length))*100).toFixed(0)+'%');
            this.pieChart.data.labels.push(' ');
            this.pieChart.data.series.push((parseInt(category.count)/parseInt(this.listExpenses.length))*100);
            let categoryName = categoriesMap.get(category.id_expense_category);
            this.pieChart.data.names.push(categoryName);
            this.pieChart.data.values.push(category.value);
          })
          itemsByVehicle.forEach(vehicle =>{
            this.pieChartVehicle.data.percentage.push(((parseInt(vehicle.count)/parseInt(this.listExpenses.length))*100).toFixed(0)+'%');
            this.pieChartVehicle.data.labels.push(' ');
            this.pieChartVehicle.data.series.push((parseInt(vehicle.count)/parseInt(this.listExpenses.length))*100);
            let vehicleName = vehiclesMap.get(vehicle.id_vehicle);
            this.pieChartVehicle.data.names.push(vehicleName);
            this.pieChartVehicle.data.values.push(vehicle.value);
          })
          itemsByItem.forEach(item =>{
            this.pieChartItem.data.percentage.push(((parseInt(item.count)/parseInt(this.listExpenses.length))*100).toFixed(0)+'%');
            this.pieChartItem.data.labels.push(' ');
            this.pieChartItem.data.series.push((parseInt(item.count)/parseInt(this.listExpenses.length))*100);
            let itemName = itemsMap.get(item.id_expense_item);
            this.pieChartItem.data.names.push(itemName);
            this.pieChartItem.data.values.push(item.value);
          })
          this.popupReport=true;
          const component = this.$refs.chart;
          component.initChart();
          const componentVehicle = this.$refs.chartVehicle;
          componentVehicle.initChart();
          const componentItem = this.$refs.chartItem;
          componentItem.initChart();
        },
        pdfReportExpenses(){
          let url = `${serverUrl}/api/pdf-report-expenses/${this.id_company}/${this.inicio}/${this.fin}/${this.filter}`;
          window.open(url , '_blank');
        },
        excelReportExpenses(){
          let url = `${serverUrl}/api/excel-report-expenses/${this.id_user}/${this.inicio}/${this.fin}/${this.filter}`;
          window.open(url , '_blank');
        },
      },
      created () {
        const date=new Date();
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = date.getFullYear();
        this.inicio = `${anio}-${mes}-${dia}`;
        this.fin = `${anio}-${mes}-${dia}`;
      },
      async mounted () {
        await this.getListExpenses();
        this.getListCategories();
        this.getListItems();
        this.getListVehicles();
        this.validateStatus();
      }
    }
  </script>
  <style>
    .vs-button{
      width: auto!important;
      font-size: 1rem!important;
    }
    .custom-money{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: flex-start;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      position: relative;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: .4rem;
      color: inherit;
      position: relative;
      padding: .4rem;
      border-radius: 5px;
      border: 1px solid rgba(0,0,0,.2);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.15);
      box-shadow: 0 0 0 0 rgba(0,0,0,.15);
      -webkit-transition: all .3s ease;
      transition: all .3s ease;
      width: 100%;
    }
    .custom-money:focus{
      border: 1px solid rgba(var(--vs-primary),1)!important;
      border: 1px solid rgba(0,0,0,.2);
    }
    .ct-chart {
        margin: 0;
        height: auto !important;
    }
    .con-vs-popup.fullscreen .vs-popup {
      width: 70%!important;
      height: auto!important;
    }
  </style>